import { Helmet } from 'react-helmet-async';

import MainRouter from './MainRouter';
import ErrorBoundary from '../components/ErrorBoundary';
import ScrollToTop from '../components/ScrollToTop';


const AppLayout = () => (
  <ErrorBoundary>
    <Helmet>
      <title>Jobs Widget</title>
    </Helmet>
    <ScrollToTop>
      <MainRouter />
    </ScrollToTop>
  </ErrorBoundary>
);

export default AppLayout;
